<p-drawer 
    header="Posizione" 
    (onHide)="onClose.emit()" 
    [visible]="isDialogVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[80rem]">
    
    <div class="grid grid-cols-4 gap-4">
        <div class="col-span-3">
            @if(data()){
            <spike-isin-form [form]="form" [isCompact]="false"></spike-isin-form>
            <spike-investment-overview [investmentRecap]="data()!"></spike-investment-overview>
            <div class="flex justify-end mt-4">
                <p-button (click)="openBuy()" class="mr-2" label="Compra" icon="pi pi-plus" size="small"></p-button>
                <p-button (click)="openSell()" class="mr-2" label="Vendi" icon="pi pi-minus" size="small"></p-button>
                <p-button (click)="openDividend()" class="mr-2" label="Dividendo" icon="pi pi-equals" size="small"></p-button>
            </div>
            <div class="spike-table-card mt-2">
                <spike-investment-trades-table [investmentRecap]="data()!" (onSelect)="openInvestmentSidepanel($event)"></spike-investment-trades-table>
            </div>
            }
        </div>
        <div>
            @if(isinValues()){
            <b>Lista valori isin</b>
            <div class="spike-card">
                <p-button (click)="openIsinValueSidepanel()" class="mr-2" label="Aggiugni" icon="pi pi-plus" size="small"></p-button>
                <spike-isin-value-list [list]="isinValues()!" (onSelect)="openIsinValueSidepanel($event)"></spike-isin-value-list>
            </div>
            }
        </div>
    </div>

    
    <ng-template #footer>
        <div class="flex gap-4 w-full justify-between">

        @if(formView()){
        <div class="w-full">
            <p-button (click)="onSaveClicked()" [disabled]="form.invalid" icon="pi pi-save" label="Salva" severity="primary" styleClass="w-full"></p-button>
        </div>
        } @if(!formView()){
            <div class="flex gap-2">
                <p-button (click)="onDeleteClicked()" icon="pi pi-trash" severity="danger" [outlined]="true"></p-button>
            </div>
            <div class="flex gap-2 w-full justify-end">
                <p-button 
                    class="w-full"
                    styleClass="w-full"
                    (click)="formView.set(true)" 
                    icon="pi pi-pencil" 
                    label="Modifica"
                    severity="secondary">
                </p-button>
            </div>
        }
        </div>
    </ng-template>
</p-drawer>



@if(isSidepanelInvestmentVisible()){
    <spike-investment-side-panel 
        [(isDialogVisible)]="isSidepanelInvestmentVisible"
        [data]="selectedInvestment()"
        [finIsinId]="data()!.finIsinId!"
        [investmentType]="investmentType()"
        (onSave)="investmentSaved()"
        (onDelete)="investmentDeleted()"
        (onClose)="closeInvestmentSidePanel()"/>
}

@if(isSidepanelIsinValueVisible()){
    <spike-isin-value-side-panel 
        [(isDialogVisible)]="isSidepanelIsinValueVisible"
        [data]="selectedIsinValue()"
        [finIsinId]="data()!.finIsinId!"
        (onSave)="isinValueSaved()"
        (onDelete)="isinValueDeleted()"
        (onClose)="closeIsinValueSidePanel()"/>
}
